<template>
  <v-dialog
    v-model="visible"
    max-width="920"
    content-class="global-image-preview-dialog"
    @click:outside="close"
  >
    <v-card class="preview-card" data-no-image-preview>
      <div class="preview-toolbar d-flex align-center justify-space-between">
        <span class="preview-title">Image Preview</span>
        <div class="d-flex align-center">
          <v-btn
            v-if="resolvedUrl"
            icon
            small
            :href="resolvedUrl"
            target="_blank"
            rel="noopener noreferrer"
            title="Open in new tab"
          >
            <v-icon>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon small aria-label="Close" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="preview-body">
        <img
          v-if="resolvedUrl"
          :src="resolvedUrl"
          alt="Preview"
          class="preview-image"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { imagePreviewBus } from "@/plugins/imagePreview";

export default {
  name: "ImagePreviewDialog",
  data() {
    return {
      visible: false,
      resolvedUrl: "",
    };
  },
  mounted() {
    imagePreviewBus.$on("open", this.open);
  },
  beforeDestroy() {
    imagePreviewBus.$off("open", this.open);
  },
  methods: {
    open(url) {
      if (!url) return;
      this.resolvedUrl = url;
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.resolvedUrl = "";
    },
  },
};
</script>

<style scoped>
.preview-card {
  border-radius: 14px !important;
  overflow: hidden;
  background: #0f172a;
}

.preview-toolbar {
  padding: 10px 14px;
  background: #fff;
}

.preview-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.preview-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  max-height: 85vh;
  background: #0b1220;
  padding: 16px;
}

.preview-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
}
</style>
